const reasons = [
  {
    title: 'Intervention rapide sous 24-48h',
    description: 'Nous savons qu\'une baie bloquée ou un volet en panne est urgent. Nos techniciens se déplacent dans tout l\'Hérault sous 24 à 48h, 7j/7.',
    icon: 'ri-speed-up-line',
  },
  {
    title: 'Techniciens qualifiés et formés',
    description: 'Nos réparateurs maîtrisent tous les types de menuiseries aluminium et PVC, avec une expertise pointue sur les baies coulissantes.',
    icon: 'ri-user-star-line',
  },
  {
    title: 'Toutes marques aluminium',
    description: 'Technal, Sepalumic, Schüco, K-Line, Wicona… Nous intervenons sur l\'ensemble des marques de menuiseries alu du marché.',
    icon: 'ri-building-2-line',
  },
  {
    title: 'Devis transparent et gratuit',
    description: 'Un diagnostic clair, un devis détaillé sans engagement. Vous savez exactement ce qui est à réparer et combien cela coûte avant toute intervention.',
    icon: 'ri-file-text-line',
  },
  {
    title: 'Garantie 10 ans sur les réparations',
    description: 'Toutes nos réparations sont couvertes par une garantie décennale. Nous utilisons des pièces de qualité professionnelle pour un résultat durable.',
    icon: 'ri-shield-check-line',
  },
  {
    title: 'Entreprise déclarée et assurée',
    description: 'DF PRO est une SAS immatriculée avec TVA intracommunautaire. Vous êtes protégé par une assurance responsabilité civile professionnelle.',
    icon: 'ri-verified-badge-line',
  },
];

export default function WhyUs() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-3">
            Pourquoi choisir DFPRO Hérault ?
          </h2>
          <p className="text-secondary-500 font-body text-base md:text-lg max-w-xl mx-auto">
            Une entreprise de confiance pour la réparation de vos menuiseries dans l'Hérault.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason) => (
            <div key={reason.title} className="flex gap-4 p-5 rounded-lg bg-background-50">
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500 shrink-0">
                <i className={`${reason.icon} text-xl`}></i>
              </span>
              <div>
                <h3 className="font-heading font-semibold text-base text-primary-500 mb-1.5">
                  {reason.title}
                </h3>
                <p className="text-secondary-500 text-sm font-body leading-relaxed">
                  {reason.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}